export const MAX_USERNAME_LENGTH = 16;
export const INVALID_CHARS_FOR_REMOVAL_REGEX = /[^a-z0-9._]/g;
export const CONSECUTIVE_SPECIAL_CHARS_REGEX = /[._]{2,}/g;
export const MAX_NAME_LENGTH = 50;
export const sanitizeUsername = (input: string): string => {
  const sanitized = input
    .toLowerCase()
    .replace(INVALID_CHARS_FOR_REMOVAL_REGEX, '')
    .replace(CONSECUTIVE_SPECIAL_CHARS_REGEX, (match) => match[0]);

  return sanitized.slice(0, MAX_USERNAME_LENGTH);
};

export const sanitizeName = (input: string): string => {
  return input
    .replace(/[^a-zA-Z\s]/g, '')
    .replace(/\s+/g, ' ')
    .slice(0, MAX_NAME_LENGTH);
};
